import React from "react";
import { PageNewState, UserSearchDialogInitialState } from ".";

export const UserSearchDialogContext = React.createContext({
  pageState: UserSearchDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
